<template>
    <div>

        <!-- Table -->

        <trax-ui-ajax-simple-table
            :id="id" :header="header" :header-color="headerColor"
            :endpoint="endpoint" :endpoint-params="endpointParams" :rows="rows" :cols="cols" :bus="bus">
        </trax-ui-ajax-simple-table>

        <!-- Flight hours modal -->

        <trax-ui-modal-plain-header :id="id+'-modal'" :bus="bus">
            <enac-atpl-dashboard-flight-hours :id="id" :bus="bus">
            </enac-atpl-dashboard-flight-hours>
        </trax-ui-modal-plain-header>

    </div>
</template>

<script>
    export default {

        props: {
            id: { default: 'enac-atpl-dashboard-phase-leaners' },
            header: { default: 0 },
            headerColor: { default: 'primary' },
            facesFolder: {default: app_url},
            facesDefault: {default: 'polaris/img/lib/misc/avatar.jpg'}
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/registrations/'+data.registration.id,
                endpointParams: {
                    accessors: ['members']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/phases/'+data.phase.id+'/learners',
                registration: data.registration,
                phase: data.phase,
                aggregation_dashboard_routes: data.aggregation_dashboard_routes,
                cols: [
                    {width: '50px'},
                    {},
                    {},
                    {},
                    {}
                ],
                learners : null,
                states : null,
                rows: [],
                bus: new Vue()
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.getStates();
        },

        mounted: function() {
            var that = this;

            $('#'+this.id+'-table tbody').on( 'click', 'button.flight-hours', function(event) {
                var learnerId = $(this).attr('data-id');
                var color = $(this).attr('data-color');
                var state = that.states[learnerId];
                if (!state || !state.flight_hours || !state.flight_hours.length) return;
                that.open(learnerId, state.flight_hours, color);
            });
        },

        updated: function() {
            $("#"+this.id+"-table .peity.donut").peity("donut");
        },

        methods: {

            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.setStates(response.data);
                    })
                    .catch(function (error) {
                    });
            },

            setData(data) {
                var learners = data.data.members;
                learners.sort(function(a, b) {
                    if (a.lastname < b.lastname) return -1;
                    if (a.lastname > b.lastname) return 1;
                    return 0;
                });
                this.learners = learners;
                if (this.states) this.updateRows();
            },

            setStates(data) {
                this.states = data.data;
                if (this.learners) this.updateRows();
            },

            updateRows() {
                this.rows = [];
                for (var index in this.learners) {
                    var learner = this.learners[index];
                    this.rows.push([
                        this.picture(learner),
                        this.name(learner),
                        this.status(learner),
                        this.trainingAlerts(learner),
                        this.flightHours(learner),
                    ]);
                }
            },

            open(learnerId, flightHours, color) {
                for (var index in this.learners) {
                    var learner = this.learners[index];
                    if (learner.id == learnerId) {
                        var data = { flight_hours: flightHours, location: this.location()};
                        this.bus.$emit(this.id+'-modal-open', {
                            headerColor: color,
                            icon: 'flight',
                            title: learner.lastname + ' ' + learner.firstname,
                            data: data
                        });
                        return;
                    }
                }
            },

            location() {
                if (this.phase.custom && this.phase.custom.location) {
                    return this.phase.custom.location.name
                } else if (this.phase.location) {
                    return this.phase.location.name
                } else {
                    return ''
                }
            },

            picture(learner) {
                var src = learner.avatar ? learner.avatar : this.facesFolder + this.facesDefault;
                var html = '<img src="'+src+'" class="avatar">'
                return this.link(learner, html);
            },

            name(learner) {
                var html = learner.lastname + ' ' + learner.firstname;
                var entity = '';
                if (learner.entity) entity = learner.entity.name;
                if (learner.subentity) entity += ' / ' + learner.subentity.name;
                html += '<br><small>'+entity+'</small>';
                return this.link(learner, html);
            },

            status(learner) {
                if (!this.states) return '';
                var state = this.states[learner.id];
                if (!state) return '';
                var html = '<div class="mt-1">';
                html += '<span class="peity donut" data-peity=\'{ "fill": ["#9c27b0", "#eeeeee"], "innerRadius": 10, "radius": 12 }\'>';
                html += state.completion.percent + '/100</span>';
                html += '<small class="ml-1">'+state.completion.percent+'%</small>';
                html += '</div>';
                return this.link(learner, html);
            },

            trainingAlerts(learner) {
                if (!this.states) return '';
                var state = this.states[learner.id];
                if (!state || !state.training_alerts) return '';
                var html = '<i class="material-icons text-danger">report_problem</i>';
                return this.link(learner, html);
            },

            flightHours(learner) {
                if (!this.states) return '';
                var state = this.states[learner.id];
                if (!state || !state.flight_hours || !state.flight_hours.length) return '';

                // Parse hours
                var color = 'success';
                var hours = 0;
                for (var index in state.flight_hours) {
                    var category = state.flight_hours[index];
                    if (typeof category.global !== "undefined") {
                        category = category.global;
                    }
                    if (category.key == 'total') {
                        hours = category.time_spent;
                    } else if (category.display && category.time_spent < category.duration) {
                        color = 'danger';
                    }
                }

                // HTML
                var html = '';
                html += '<button class="flight-hours btn btn-sm btn-link pr-1 pl-1 btn-'+color+'" data-id="'+learner.id+'" data-color="'+color+'">';
                html += '   <i class="material-icons">flight</i> ';
                html +=     hours+'H';
                html += '</button>';
                return html;
            },

            link(learner, content) {
                var routes = this.aggregation_dashboard_routes;
                var href = routes[this.phase.type]+'/registration/'+this.registration.id+'/'+this.phase.type+'/'+this.phase.id+'/learner/'+learner.id;
                return '<a href="'+href+'">'+content+'</a>';
            }
        }
    }
</script>
